// extracted by mini-css-extract-plugin
export default {"container":"Dn-z","blurb":"En-z","links":"Fn-z"};